import { useContext, useEffect, useState } from 'react'
import { LoginContext } from '../../contexts/login-context'
import { GlobalStyle } from '../../styles/global-styles'
import SeatPicker from '../../components/seat-picker/seat-picker'
import { Calendar } from '../../components/atoms'
import ContentCard from '../../components/atoms/ContentCard/content-card'
import UserBookings from '../../components/user-bookings/user-bookings'
import {
  HomePageContainer,
  HomeRowSection,
  HomeColumnSection,
  PageTitle,
  SubHeader,
  ErrorMessage,
  ErrorIcon
} from './home-styles'
import { ApiContext } from '../../contexts/api-context'
import { BookingErrors, BusinessUnit, ListOption } from '../../types/andTypes'
import { formatToReadableDate } from '../../utilities/utils'
import useBusinessUnit from '../../hooks/useBusinessUnit'
import ComboBox from '../../components/atoms/ComboBox/combobox'
import useTodaysSeats from '../../hooks/useTodaysSeats'
import logAnalyticsEvent from '../../utilities/firebase-analytics'
import { BookingListLabel } from '../../components/user-bookings/booking-type-label'
import { ModalContext } from '../../contexts/modal-context'
import Error from '../../components/modal/popup/assets/error.svg'
import { LocationError } from '../../components/modal/popup/group-booking-popup/group-booking-popup-styles'

const Home = () => {
  const { user } = useContext(LoginContext)
  const { businessUnits, userProfile } = useContext(ApiContext)
  const { selectedBUId, setSelectedBUId, seatsBooked } = useBusinessUnit()
  const [selectedBU, setSelectedBU] = useState<BusinessUnit | undefined>(
    businessUnits.find(bu => bu.id === selectedBUId)
  )
  /* eslint-disable no-console */
  const {
    isUserBooked,
    selectedDaysSeats,
    seletedDaysSeatsForAllBu,
    selectedDay,
    setSelectedDay,
    isPublicHoliday
  } = useTodaysSeats(selectedBU)
  const buOptions = businessUnits as unknown as ListOption[]
  const dateString = formatToReadableDate(selectedDay)
  const { modalOpen } = useContext(ModalContext)
  const [error, setError] = useState('')
  logAnalyticsEvent('page_view', {
    page_location: '/',
    page_title: 'Home',
    user: user?.email,
    team: userProfile?.team
  })

  useEffect(() => {
    setErrorMessage()
  }, [])

  useEffect(() => {
    const newSelectedBu = businessUnits.find(bu => bu.id === selectedBUId)
    setSelectedBU(newSelectedBu)
    if (newSelectedBu?.deskCapacity === 0) {
      setError(BookingErrors().LOCATION_NOT_YET_READY)
    } else {
      setError('')
    }
  }, [selectedBUId])

  const setErrorMessage = () => {
    if (selectedBU?.deskCapacity === 0) {
      setError(BookingErrors().LOCATION_NOT_YET_READY)
    } else {
      setError('')
    }
  }

  return (
    <>
      <GlobalStyle page="home" />
      <HomePageContainer>
        <PageTitle>Hello, {user?.displayName}!</PageTitle>
        <HomeRowSection>
          <HomeColumnSection>
            {selectedBU && (
              <>
                <ContentCard header="Book your desk">
                  <ComboBox
                    listItems={buOptions}
                    listValue={selectedBUId}
                    setListValue={setSelectedBUId}
                    disabled={modalOpen}
                    valueProperty="id"
                    displayTemplate="{name}, {location}"
                    label="Select where you would like to work"
                    errorHandle={setErrorMessage}
                  />
                  <>
                    {error ? (
                      <LocationError>
                        <ErrorIcon src={Error} />
                        <ErrorMessage>{error}</ErrorMessage>
                      </LocationError>
                    ) : null}
                  </>
                  <SubHeader>Select Date</SubHeader>
                  <Calendar
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    seatsBookings={seatsBooked}
                    seatCap={selectedBU.deskCapacity}
                    region={selectedBU.region}
                  />
                  <SubHeader>Book a desk on {dateString}</SubHeader>
                  <SeatPicker
                    bookedAndis={selectedDaysSeats}
                    bookedAndisForAllBu={seletedDaysSeatsForAllBu}
                    isUserBooked={isUserBooked}
                    selectedDay={selectedDay}
                    selectedBU={selectedBU}
                    isBankHoliday={isPublicHoliday}
                  />
                </ContentCard>
              </>
            )}
          </HomeColumnSection>
          <HomeColumnSection>
            <BookingListLabel />
            <ContentCard header="My Booking list">
              <UserBookings />
            </ContentCard>
          </HomeColumnSection>
        </HomeRowSection>
      </HomePageContainer>
    </>
  )
}
export default Home
